import { Dispatch } from "redux"; 
import api from "../../api/api";
import {
setFreeDomain, isloading, seterror, resetFreeDomain} from "../reducers/getFreeDomainReducer";
// import { updateGlobalState } from "../global/slice";

const getFreeDomain = (token: any) => async (dispatch: Dispatch) => {

    dispatch(isloading(true));
    try {
        const result = await api
            .get(
                `auth/users/domains/`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            )
        if (result) {
            dispatch(isloading(false));
            if (result?.status === 200) {

                dispatch(setFreeDomain(result?.data?.domains));
            }
            else {
                dispatch(seterror(result?.statusText ?? "Something went wrong"));
            }
        }
    }
    catch (error: any) {
        dispatch(seterror(error.response.data.message || "Something went wrong"));
    }
}

export { resetFreeDomain, getFreeDomain};


